module.exports = __webpack_public_path__ + "static/media/chuck.39b94c0e.png";